module.exports = __webpack_public_path__ + "img/close.042147ca.svg";